import React from 'react'
import ScreenLayout from '../../layout/ScreenLayout/ScreenLayout'
import { ActiveRentProgContainer } from '../../components/ActiveRentProgContainer/ActiveRentProgContainer'

export const ActiveRentProgScreen = () => {
  return (
   <ScreenLayout>
    <ActiveRentProgContainer />
   </ScreenLayout>
  )
}
